module.exports = __webpack_public_path__ + "static/schoolsforasia_business3@2x-43399332de7198e818010fe064898746.png";